module.exports = __webpack_public_path__ + "img/exclamation.f11e7f8a.png";